import { Pagination } from '@deckplan.io/common';
import { Query } from '@deckplan.io/common/filters';
import * as qs from 'qs';
import { environment } from '../../../environments/environment';

export class UrlUtils {

    public static constructBackendUrl(backendControllerPrefix: string): string {
        return `${environment.apiUrl}/${environment.apiVersion}/${backendControllerPrefix}`;
    }

    public static constructPaginationAndFilterUrl(urlPrefix: string, pagination: Partial<Pagination>, query: Query): string {
        if (pagination && query) {
            urlPrefix += `?pagination=${encodeURIComponent(qs.stringify(pagination))}&filter=${encodeURIComponent(qs.stringify(query))}`;
        } else if (pagination) {
            urlPrefix += `?pagination=${encodeURIComponent(qs.stringify(pagination))}`;
        } else if (query) {
            urlPrefix += `?filter=${encodeURIComponent(qs.stringify(query))}`;
        }

        return urlPrefix;
    }
}
